import React from 'react'
import ShapeAnimation from '../../../ShapeAnimation'

const Banner = () => {
    return (
        <>
            <div className="web-development-banner">
                <div className="d-table">
                    <div className="d-table-cell">
                        <div className="container"></div>
                    </div>
                </div>
                <ShapeAnimation/>
            </div>

        </>
    )
}

export default Banner